import * as z from "zod";

export const getMarketplacePayouts = {
  name: "getMarketplacePayouts" as const,
  input: z.any(),
  output: z.object({
    balance: z.number(),
    payouts: z.array(
      z.object({
        id: z.string(),
        amount: z.string(),
        status: z.string(),
        createdAt: z.date(),
        updatedAt: z.date(),
      }),
    ),
  }),
};
